import * as React from 'react';

import MapContext from './context';

function useMap() {
  const context = React.useContext(MapContext);

  if (!context) {
    throw new Error('useMap must be used within a MapProvider');
  }

  return context;
}

export default useMap;